import React, { Component } from 'react';
import * as d3 from "d3";
import d3Tip from 'd3-tip';

import '../../../css/UserCharts.css';

class AsterChart extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      data: props.data,
      type: props.type,
      label: props.label,
      clickCb: props.clickCb
    }

  }

  componentWillReceiveProps(newProps) {
    
    this.setState({
      data: newProps.data,
      type: newProps.type,
      label: newProps.label,
      clickCb: newProps.clickCb
    });

    this.renderAsterChart();
  }

  componentDidMount() {
    this.renderAsterChart();
    this.eventHandler = this.updateDimensions.bind(this);
    window.addEventListener("resize", this.eventHandler);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.eventHandler);
    d3.selectAll('.d3-tip').remove();
  }

  updateDimensions() {
    let data = this.state.data;
    if (!data || (this.lastWidth && this.lastWidth === this.getWidth()))
      return;
    this.renderAsterChart();
  }

  getWidth() {
    let width = document.getElementById('container').offsetWidth*0.96;
    return width;
  }

  isLargeEnough() {
    return this.getWidth() >= 550;
  }

  renderAsterChart() {

    let data = this.state.data;
    let type = this.state.type;
    let onClickCb = this.state.clickCb;

    if (!data)
      return;

    let height = this.isLargeEnough() ? 450 : 200;

    d3.selectAll('.d3-tip').remove();

    if (this.refs.asterChart)
      d3.select(this.refs.asterChart).html('');

    let width =  this.getWidth();
    this.lastWidth = width;
    
    let color = d3.scale.category20c();
    
    data = data.items.map(function(item){
      return {label: item.key, count: item.value, score: (item.ratio*100).toFixed(2), weight: 1, width: 1, color: color(item.key) };
    });

    let label = function(d){ return d.data.label; };

    this.tip = d3Tip()
      .attr('class', 'd3-tip')
      .offset([0, 0])
      .html(function(d) {
        return d.data.label + ": <span style='color:orangered'>" + d.data.count + " ~ " + d.data.score + "% </span>";
      });
    

    let svg = d3.select(this.refs.asterChart)
      .attr("width", width)
      .attr("height", height);

    svg = svg.append("g");

    let radius = 0.4*Math.min(width, height),
    innerRadius = 0.5 * radius;

    let pie = d3.layout.pie()
        .sort(null)
        .value(function(d) { return d.width; });

    let arc = d3.svg.arc()
      .innerRadius(innerRadius)
      .outerRadius(function (d) { 
        return (radius - innerRadius) * (d.data.score / 100.0) + innerRadius; 
      });

    let outlineArc = d3.svg.arc()
        .innerRadius(innerRadius)
        .outerRadius(radius);

    svg.append("g")
      .attr("class", "slices");
    svg.append("g")
      .attr("class", "labels");
    svg.append("g")
      .attr("class", "lines");
      

    svg.attr("transform", "translate(" + (width / 2) + "," + ((height / 2)) + ")");

    svg
      .select('.slices')
      .call(this.tip);
    
    //outer path
    svg.select('.slices').selectAll(".outlineArc")
      .data(pie(data))
      .enter().append("path")
      .attr("fill", "none")
      .attr("stroke", "gray")
      .attr("class", "outlineArc")
      .attr("d", outlineArc)

    //solid arcs
    svg.select('.slices').selectAll(".solidArc")
      .data(pie(data))
      .enter().append("path")
      .attr("fill", function(d) { return d.data.color; })
      .attr("class", "solidArc")
      .attr("opacity", "0.7")
      .attr("stroke", "gray")
      .attr("d", arc)
      .on('mouseover', this.tip.show)
      .on('mouseout', this.tip.hide)
      .on('click', function(evt){
        let name = evt.data.label;
        let lowerCaseName = name.toLowerCase();
        if (lowerCaseName !== 'others' && lowerCaseName !== 'other' && lowerCaseName !== 'unknown' && lowerCaseName !== 'mixed')
        {
          onClickCb(name, type);
        }
        
      });


    // calculate the weighted mean score
    let score = 
      data.reduce(function(a, b) {
        return a + (b.score * b.weight); 
      }, 0) / 
      data.reduce(function(a, b) { 
        return a + b.weight; 
      }, 0);

    svg.select('.slices').append("svg:text")
      .attr("class", "aster-score")
      .attr("dy", ".35em")
      .attr("text-anchor", "middle")
      .text(Math.round(score));


    let text = svg.select('.labels')
      .selectAll("text")
      .data(pie(data), label);

    text
      .enter()
      .append("text")
      .attr("dy", ".35em")
      .text(function(d) {
        return d.data.label;
      });
  

    function midAngle(d){
      return d.startAngle + (d.endAngle - d.startAngle)/2;
    }

    text.transition().duration(1000)
      .attrTween("transform", function(d) {
        this._current = this._current || d;
        let interpolate = d3.interpolate(this._current, d);
        this._current = interpolate(0);
        return function(t) {
          let d2 = interpolate(t);
          let pos = outlineArc.centroid(d2);
          pos[0] = radius * (midAngle(d2) < Math.PI ? 1 : -1);
          return "translate("+ pos +")";
        };
      })
      .styleTween("text-anchor", function(d){
        this._current = this._current || d;
        let interpolate = d3.interpolate(this._current, d);
        this._current = interpolate(0);
        return function(t) {
          let d2 = interpolate(t);
          return midAngle(d2) < Math.PI ? "start":"end";
        };
      });

    text.exit()
      .remove();

    let polyline = svg.select(".lines").selectAll("polyline")
      .data(pie(data), label);
  
    polyline.enter()
      .append("polyline");

    polyline.transition().duration(1000)
      .attrTween("points", function(d){
        this._current = this._current || d;
        let interpolate = d3.interpolate(this._current, d);
        this._current = interpolate(0);
        return function(t) {
          let d2 = interpolate(t);
          let pos = outlineArc.centroid(d2);
          pos[0] = radius * 0.95 * (midAngle(d2) < Math.PI ? 1 : -1);
          return [arc.centroid(d2), outlineArc.centroid(d2), pos];
        };      
      });
    
    polyline.exit()
      .remove();
   
  }

  render() {

    let className = this.isLargeEnough() ? 'large' : '';

    return (
      <svg className={className} ref="asterChart" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision">
      </svg> 
    );
  }

}

export default AsterChart;



// WEBPACK FOOTER //
// ./src/js/components/charts/AsterChart.jsx